import { Injectable, Component, HostListener } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavController, MenuController, AlertController } from '@ionic/angular';
import { HttpService } from './http.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public show_sidemenu = true;
  
  public user_data = null;
  public isLoading = false;
  public defaultTimeOffset = 480;
  public img_head = "http://webstorage3.innpressionhost.com/Media/";
  constructor(
    private _snackBar: MatSnackBar,
    private nav: NavController,
    public menuCtrl: MenuController,
    private alertController: AlertController,
    private httpService: HttpService,
    public dialog: MatDialog
  ) { 
    if (window.innerWidth <= 992) {
      this.show_sidemenu = false;
    }
  }

  toggleMenu() {
    if (this.show_sidemenu) {
      this.show_sidemenu = false;
    }
    else {
      this.show_sidemenu = true;
    }
  }

  ToPage(page) {
    this.nav.navigateForward(page);
  }
  BackPage() {
    this.nav.back();
  }

  OpenNewTab(url) {
    console.log(url);
    window.open(url, '_blank');
  }

  openSnackBar(message: string, action?: string, durantion?: number, horizontalPosition?, verticalPosition?) {
    this._snackBar.open(message, (action != undefined ? action : 'OK'), {
      duration: (durantion != undefined ? durantion : 2500),
      horizontalPosition: (horizontalPosition != undefined ? horizontalPosition : "start"),
      verticalPosition: (verticalPosition != undefined ? verticalPosition : "bottom"),
    });
  }

  Logout() {
    window.localStorage.removeItem("hectoron_admin_data");
    this.user_data = null;
    this.nav.navigateRoot('login');
  }

  async deleteDataAlert(data_type, id) {
    if (this.isLoading) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result) {
        console.log(result);
        if (result == true) {
          this.deleteData(data_type, id);
        }
      }
    });

  }

  deleteData(data_type, id) {
    this.isLoading = true;
    this.httpService.DeleteDataByDataTypeAndId(data_type, id).then((res) => {
      console.log(res);
      if (res.result == "success") {

        this.isLoading = false;
        this.openSnackBar("Data deleted");
        this.BackPage();

      }
    })
  }


  currentTimeString(date) {
    var now = date;
    if (now == "") {
      now = new Date();
    }
    return now.getUTCFullYear() + "-" + this.NumberCovert(now.getMonth() + 1) + "-" + this.NumberCovert(now.getDate()) + "T" + this.NumberCovert(now.getHours()) + ":" + this.NumberCovert(now.getMinutes()) + ":" + this.NumberCovert(now.getSeconds()) + "Z";
  }

  getUTCoffset() {
    var str = '';
    const offsetMin = -(new Date().getTimezoneOffset());
    const value = Math.abs(offsetMin);
    if (offsetMin > 0) {
      str = '+' + this.NumberCovert(Math.floor(value / 60)) + ':' + this.NumberCovert(Math.floor(value % 60));
    } else {
      str = '-' + this.NumberCovert(Math.floor(value / 60)) + ':' + this.NumberCovert(Math.floor(value % 60));
    }
    return {
      iso: str,
      offset: offsetMin
    };
  }

  NumberCovert(num) {
    if (parseInt(num) < 10) {
      return "0" + num;
    } else {
      return num;
    }
  }

  convertLocalToServerTime(str) {

    var timezone = this.getUTCoffset();

    if (str[str.length - 1] == 'Z') {
      if (timezone.offset != this.defaultTimeOffset) {
        str = str.slice(0, -1);
        str += timezone.iso;
        var localDateTime = new Date(str).getTime() - (timezone.offset - this.defaultTimeOffset) * 60 * 1000;
        var converted = this.convertTimestamp(localDateTime);
        return (converted.year + '-' + converted.month + '-' + converted.day + 'T' + converted.hr + ':' + converted.min + ':' + converted.sec + 'Z');
      } else {
        return str;
      }
    } else {
      console.log('Invalid JSON Time Format: ' + str);
      return str;
    }
  }

  convertTimestamp(t) {
    var a = new Date(t);
    return {
      year: a.getFullYear().toString(),
      month: this.NumberCovert(a.getMonth() + 1).toString(),
      day: this.NumberCovert(a.getDate()).toString(),
      hr: this.NumberCovert(a.getHours()).toString(),
      min: this.NumberCovert(a.getMinutes()).toString(),
      sec: this.NumberCovert(a.getSeconds()).toString(),
      weekday: a.getDay()
    };
  }
}
@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm-dialog.html',
})
export class ConfirmDialog {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>
  ) {
  }

  close() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }


}